// removed by extract-text-webpack-plugin
module.exports = {"testimonialWrap":"qempo_Testimonial_testimonialWrap-3B1HBqd","testimonial":"qempo_Testimonial_testimonial-2dVF-Qo","purchaser":"qempo_Testimonial_purchaser-25CrzBn","traveler":"qempo_Testimonial_traveler-1Yt0W_T","imageWrap":"qempo_Testimonial_imageWrap-1NSX_pr","discover":"qempo_Testimonial_discover-38oY__U","lightBlue":"qempo_Testimonial_lightBlue-o9ObaR6","orange":"qempo_Testimonial_orange-1bEmCWe","content":"qempo_Testimonial_content-3-s43kf","name":"qempo_Testimonial_name-1vpJMdQ","flight":"qempo_Testimonial_flight-3f4UgxE","text":"qempo_Testimonial_text-3Cyf6MO"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/CarouselTestimonials/Testimonial/Testimonial.scss
// module id = 1417
// module chunks = 0